import React from 'react';
import {
  ButtonTertiary,
  IconChevronDown,
  IconChevronUp,
  cssColorValue,
  desktopMestoBold,
  semanticColors,
} from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';

// This is a fallover from the work on S4A masthead which we used as a base for our masthead
const CustomTertiaryButton = styled(ButtonTertiary)`
  color: ${cssColorValue(semanticColors.textBase)};
  cursor: pointer;
  padding: 0;
  min-block-size: auto;
  ${desktopMestoBold};

  && {
    text-decoration: none;

    &:active,
    &:hover,
    &:focus {
      transform: none;
    }

    &:hover,
    &:focus {
      color: ${cssColorValue(semanticColors.textBrightAccent)};
    }

    &::after {
      inline-size: 100%;
      bottom: -3px;
    }
  }

  && > * {
    margin-inline-start: 8px;
  }
`;

const StyledIconChevronDown = styled(IconChevronDown)`
  transform: translateY(1px);
`;

const StyledIconChevronUp = styled(IconChevronUp)`
  transform: translateY(3px);
`;

interface Props extends React.ComponentProps<typeof CustomTertiaryButton> {
  open: boolean;
  showNewAccountEntryPoint?: boolean;
}

export const PopoverTriggerButton = ({
  open,
  onKeyDown,
  onMouseDown,
  showNewAccountEntryPoint,
  children,
  ...props
}: Props) => {
  const { t } = useTranslation();
  return (
    <CustomTertiaryButton
      href=""
      iconTrailing={() =>
        open ? (
          <StyledIconChevronUp size="small" aria-label={t('navbar_dropdown_menu_close')} />
        ) : (
          <StyledIconChevronDown size="small" aria-label={t('navbar_dropdown_menu_open')} />
        )
      }
      onKeyDown={onKeyDown}
      onMouseDown={onMouseDown}
      {...props}
    >
      {children}
    </CustomTertiaryButton>
  );
};
